// extracted by mini-css-extract-plugin
export default {"box":"index_box__lt-6k","header":"index_header__vlH7m"};